// extracted by mini-css-extract-plugin
export default {"DepartmentButton":"loadingDepartmentButton_DepartmentButton__Jrksg","Active":"loadingDepartmentButton_Active__64g6P"};